import lazyImporter from '@/utils/lazyImporter'

const configurationRoute = {
  component: lazyImporter('View'),
  meta: { title: 'configuration', icon: 'tune' },
  name: 'admin_configuration',
  path: '/configuration',
  redirect: { name: 'admin_configuration_update' },
  children: [
    {
      component: lazyImporter('configuration/ConfigurationUpdate'),
      meta: { title: 'configurationUpdate', hidden: true },
      name: 'admin_configuration_update',
      path: 'update',
      props: true
    }
  ]
}

export default configurationRoute
